// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__obkI7","crumb":"styles_crumb__y_BDB","label":"styles_label__P41A_","icon":"styles_icon__XyqPB"};